module.exports = __webpack_public_path__ + "static/media/logo.915a072f.svg";